import React from 'react';
import { m } from 'framer-motion';
import { CreditCardIcon, WalletIcon, SmartphoneIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { CHECKOUT_URL } from '../../utils/checkout';
import { trackMetaPixelEvent } from '../../utils/metaPixel';
const rows = [{
  content: 'Colección de Planos y Sistemas (5 Tomos)',
  value: '69€'
}, {
  content: 'Pack de Estrategia y Ventas (5 Bonos)',
  value: '89,50€'
}];
const paymentOptions = [{
  icon: CreditCardIcon,
  label: 'Tarjeta de crédito/débito'
}, {
  icon: WalletIcon,
  label: 'Paypal'
}, {
  icon: SmartphoneIcon,
  label: 'Apple Pay / Google Pay'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantizado por Whop'
}];
export function Pricing() {
  return <section id="oferta-base" className="bg-bg-secondary py-10 sm:py-14" data-id="element-147" data-mp="3a6w7w53uv20">
      <div className="mx-auto max-w-2xl px-4 sm:px-6" data-id="element-148" data-mp="2064dx2n6duoz">
        <div className="rounded-2xl bg-action px-5 py-3 text-center" data-id="element-149" data-mp="2534krfrun1h5">
          <p className="text-xs font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-150" data-mp="255hboifl4m6c">
            ⏰ Oferta de lanzamiento: solo 19€ hasta agotar las próximas 50 descargas
          </p>
        </div>
      </div>

      <div className="mx-auto mt-6 max-w-2xl px-4 text-center sm:px-6" data-id="element-151" data-mp="11kx4axzils4y">
        <SectionTag icon="💰" data-id="element-152" data-mp="11iueadyd3z08">Oferta especial de lanzamiento</SectionTag>
        <h2 className="mt-4 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-153" data-mp="xkmvldkc8nme">
          ¿Cuánto vale para ti dejar de tirar madera y empezar a facturar?
        </h2>
      </div>

      <div className="mx-auto mt-8 max-w-md px-4 sm:px-6" data-id="element-154" data-mp="1pb16r20yvlud">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-3xl border border-brown/30 bg-white p-6 shadow-card sm:p-7" data-id="element-155" data-mp="1l8ejzfj5kr41">
          <p className="font-heading text-xs font-bold uppercase tracking-wider text-muted" data-id="element-156" data-mp="4uxy3a6u75pj">
            🔨 El Kit del Taller Rentable
          </p>
          <p className="mt-1.5 text-xs text-muted" data-id="element-157" data-mp="6cd34crmz9dw">5 tomos + 5 bonos, listos para fabricar y vender.</p>

          <div className="mt-4 space-y-1.5" data-id="element-158" data-mp="ba51npmsdtr2">
            {rows.map(row => <div key={row.content} className="flex items-center justify-between gap-3 border-b border-brown/10 py-1.5 text-sm" data-id="element-159" data-mp="3thb30c4i0v4n">
                <span className="text-ink/80" data-id="element-160" data-mp="1axe69mc8iq8">{row.content}</span>
                <span className="flex-shrink-0 text-muted line-through" data-id="element-161" data-mp="3jqga4owqyxa8">{row.value}</span>
              </div>)}
            <div className="flex items-center gap-2 py-1.5 text-sm text-ink/80" data-id="element-162" data-mp="3oihuky42jubc">
              <CheckIcon size={14} className="flex-shrink-0 text-success" data-id="element-163" data-mp="39tbnyp2wj1tf" />
              Acceso de por vida a futuras actualizaciones
            </div>
            <div className="flex items-center justify-between py-1.5 text-sm font-semibold text-ink" data-id="element-164" data-mp="3epkainjfhxam">
              <span data-id="element-165" data-mp="30tyn2ksuflkb">VALOR TOTAL</span>
              <span data-id="element-166" data-mp="35rgnfmssosgp">158,50€</span>
            </div>
          </div>

          <p className="mt-4 text-xs font-medium text-muted" data-id="element-167" data-mp="35srq1jai7u68">Consíguelo hoy por solo:</p>
          <p className="font-heading text-5xl font-extrabold text-brown sm:text-6xl" data-id="element-168" data-mp="2m79gjz06c84f">19€</p>
          <p className="mt-2 text-sm text-danger" data-id="element-169" data-mp="2h7ws59tnmszq">⏰ Descuento del 88% — solo para los próximos 50 pedidos</p>

          <div className="mt-6" data-id="element-170" data-mp="2v3qv7c7qyo4x">
            <a href={CHECKOUT_URL} onClick={() => trackMetaPixelEvent('InitiateCheckout', {
            value: 19,
            currency: 'EUR'
          })} className="group flex w-full items-center justify-center gap-2 rounded-xl bg-action px-8 py-4 font-heading text-base font-bold uppercase tracking-wide text-white transition-colors duration-200 hover:bg-action-hover active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-action focus-visible:ring-offset-2 focus-visible:ring-offset-bg-primary sm:text-lg" data-id="element-171" data-mp="2r3qfzpctq8wt">
              🔨 Quiero empezar ahora
            </a>
          </div>

          <div className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2 border-t border-brown/10 pt-4 text-[11px] text-muted" data-id="element-172" data-mp="3iwqt8xxkqufm">
            {paymentOptions.map(item => <span key={item.label} className="flex items-center gap-1.5" data-id="element-173" data-mp="1m5d19xl8t0yv">
                <item.icon size={13} className="flex-shrink-0" data-id="element-174" data-mp="1m3ibo5z10kog" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}